import React, { Children } from 'react';
import classnames from 'classnames';

// Utils
import { isElementOfType, sanitizeFragments } from '../../utilities/components';

// Components
import WpLabelled from '../labelled/WpLabelled';
import WpCheckbox from './WpCheckbox';

//Styles
import './WpCheckboxGroup.scss';

export type DirectionType = 'horizontal' | 'vertical';
const DEFAULT_DIRECTION_TYPE = 'vertical';

export interface Props {
  // TODO: (josh) - removing helpText until we figure out design
  /** Additional hint text to display */
  // helpText?: React.ReactNode;
  /** Error to display beneath the label */
  error?: string;
  /** Label for the input */
  label: string;
  /** Hide the label, but keep on screen for screen readers */
  labelHidden?: boolean;
  /**  Content to display inside the Radio Group */
  children?: React.ReactNode;
  /** Callback when value is changed */
  onChange?(value: string): void;
  direction?: DirectionType;
}

const WpCheckboxGroup: React.FC<Props> = ({
  labelHidden,
  // helpText,
  label,
  children,
  error,
  direction = DEFAULT_DIRECTION_TYPE,
}: Props) => {
  const sanitizedChildren = children && sanitizeFragments(children);

  const baseClassName = 'WpCheckboxGroup';
  const classes = classnames(baseClassName, `${baseClassName}--${direction}`);
  return (
    <div className={classes}>
      <WpLabelled label={label} error={error} id={null} labelHidden={labelHidden}>
        <div className={`${baseClassName}__choices`}>
          {Children.map(sanitizedChildren, (child: React.ReactElement<any>) => {
            if (child && isElementOfType(child, [WpCheckbox])) {
              return <div className={`${baseClassName}__choices__choice`}>{child}</div>;
            }
          })}
        </div>
      </WpLabelled>
    </div>
  );
};

export default WpCheckboxGroup;
